import Data from '../Data';

// Action Types

export const Invalidate = 'canny/clickup_task_suggestions/invalidate';
export const SuggestionsError = 'canny/clickup_task_suggestions/suggestions_error';
export const SuggestionsLoaded = 'canny/clickup_task_suggestions/suggestions_loaded';

// Actions

function suggestionsLoaded(search, suggestions) {
  return {
    search,
    suggestions,
    timestamp: Date.now(),
    type: SuggestionsLoaded,
  };
}

function suggestionsError(search, error) {
  return {
    error,
    search,
    timestamp: Date.now(),
    type: SuggestionsError,
  };
}

function invalidate() {
  return {
    timestamp: Date.now(),
    type: Invalidate,
  };
}

// Action Creators

function fetchSuggestions(query) {
  return (dispatch, getState) => {
    const cookies = getState().cookies;
    return Data.fetch(
      {
        suggestions: {
          input: {
            query,
          },
          query: Data.queries.clickupTaskSuggestions,
        },
      },
      cookies,
      (error, data) => {
        if (error) {
          return dispatch(suggestionsError(query, error));
        } else {
          return dispatch(suggestionsLoaded(query, data.suggestions));
        }
      },
    );
  };
}

export function loadSuggestions(query) {
  return (dispatch, getState) => {
    if (shouldFetchSuggestions(getState(), query)) {
      return dispatch(fetchSuggestions(query));
    }

    return Promise.resolve();
  };
}

export function invalidateSuggestions() {
  return (dispatch) => {
    return dispatch(invalidate());
  };
}

// Helpers

function shouldFetchSuggestions(state, query) {
  if (typeof query !== 'string' || query.length === 0) {
    return false;
  }

  const issueSuggestions = state.issueSuggestions;
  return !issueSuggestions[query];
}
